import { useEffect, useState } from 'react';
import { _FixedAssetItem } from '../../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _single } from '../../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../../theme/Component/Modal';
import { toast } from 'react-toastify';
import useModal, { MODAL_LG } from '../../../../../theme/Component/hooks/useModal';
import { FixedAssetItem } from './FixedAssetItem';

interface Props {
    label?: string;
    idSelector?: number;
    onChange?: any;
    StateActive?: any;
    disabled?: boolean
}

export const EditorFixedAssetItem = ({ idSelector, label, onChange, StateActive, disabled }: Props) => {
    const { instance } = useDataBean(_FixedAssetItem)

    const modal = useModal("Catalogo de Activos Fijos", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    useEffect(() => {
        if (idSelector) {
            getProduct()
        }
    }, [idSelector])

    const getProduct = () => {
        instance.getFixedAssetItem(idSelector).then(
            (resp) => {
                setObj(resp);
                onChange(resp);
            }
        ).catch(err => { toast.error("Activo no encontrado") })
    }

    const returnValue = () => {
        if (obj.IDItem) {
            setValor(`${obj.IDItem} - ${obj.TicketCode} - ${obj.Name}`)
            modal.close();
            onChange(obj);
        } else {
            toast.error("Activo fijo no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Seleccione un Activo Fijo"}</label>
            <div className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal.modal} updateModal={modal.setModal} eventModal={returnValue}>
                <FixedAssetItem preFilterProps={{ State: StateActive ? [StateActive] : null }} onChange={(e) => { setObj(e) }} isModal />
            </Modal>

        </>
    )
}
